export default __webpack_public_path__ + "static/media/ACHFImg.993799ee.jpg";